import { call, put, select } from 'redux-saga/effects';
import serviceLocator, { SSAP_SVC } from '@APIs/common/service-locator';
import { setSsapSettings } from '@actions/ssap/ssapActionCreators';
import { getIsState } from '@reducers/appReducer';
import { ENABLED, DISABLED } from '@constants/ssap/miscellaneous/miscellaneous';
import { TIME_INTERVALS } from '@utils/dates/dateMethods';

const getRangeOfDays = (isState) => {
    switch (true) {
        case isState.VA:
        case isState.IL:
        case isState.NM:
            return TIME_INTERVALS.ONE_YEAR;
        case isState.PA:
            return TIME_INTERVALS.NINETY_DAYS;
        default:
            return TIME_INTERVALS.SIXTY_DAYS;
    }
};

export function* ssapSettingsSaga(...args) {
    const [ replacements ] = args;
    const isState = yield select(getIsState);
    const ssapService = yield call(serviceLocator, SSAP_SVC);
    const settings = yield call([ssapService, ssapService.getSettings], replacements);
    if(settings) {
        // All mixins are artificial ones until decision is made:
        // - to pass such settings from backend depends on configuration OR
        // - remove them and their usages;

        // Mixins go first in settings to have possibility to override them by backend
        const mixins = {
            itfFeature: settings.itfEnabled ?? (isState.PA ? ENABLED : DISABLED),
            inlineCurrentIncomeEnabled: ENABLED,
            inlineEligibilityIgnoredForEscPage: ENABLED,
            collectLivingArrangement: isState.NM ? ENABLED : DISABLED,
            endDateOfPregnancyOverride: getRangeOfDays(isState),
        };

        yield put(setSsapSettings({ ...mixins, ...settings }));
    } else {
        yield call(global.console.log, 'SSAP settings are not retrieved');
    }
}